import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";

const Category = props => {
  const { path, text, children } = props;
  const [isOpen, setOpen] = useState(false);
  return (
    <li>
      <div
        className="site__nav-overlay-category"
        onClick={() => setOpen(!isOpen)}
        onKeyDown={() => setOpen(!isOpen)}
        role="link"
        tabIndex="0"
      >
        <Link to={path}>{text}</Link>
        <Button
          onClick={() => setOpen(!isOpen)}
          aria-label="Toggle Open and Close"
        >
          <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />
        </Button>
      </div>
      <Collapse isOpen={isOpen}>
        <ul>
          {children.map(child => (
            <li key={child.id}>
              <Link to={child.path}>{child.text}</Link>
            </li>
          ))}
        </ul>
      </Collapse>
    </li>
  );
};

Category.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  ).isRequired
};

export default Category;
